import { Breadcrumb as ChakraBreadcrumb } from '@chakra-ui/react';
import React, { JSX } from 'react';
import Link from 'next/link';
import { ROUTES } from 'services/shared/routerService';
import { isNativePlatform } from 'services/shared/clientService';

interface PropsInterface {
	children?: React.ReactNode;
	navigation: { label: string; href?: ROUTES | string; current?: boolean }[];
}

function Breadcrumb(props: PropsInterface): JSX.Element {
	if (isNativePlatform()) return <></>;

	return (
		<ChakraBreadcrumb.Root mb={5}>
			<ChakraBreadcrumb.List>
				{props.navigation.map((navigation, index) => {
					return (
						<React.Fragment key={index}>
							<ChakraBreadcrumb.Item color={'fg !important'}>
								{!navigation.current ? (
									navigation.href ? (
										<ChakraBreadcrumb.Link as={Link} href={navigation.href}>
											{navigation.label}
										</ChakraBreadcrumb.Link>
									) : (
										<ChakraBreadcrumb.CurrentLink>{navigation.label}</ChakraBreadcrumb.CurrentLink>
									)
								) : (
									<ChakraBreadcrumb.CurrentLink>{navigation.label}</ChakraBreadcrumb.CurrentLink>
								)}
							</ChakraBreadcrumb.Item>
							<ChakraBreadcrumb.Separator />
						</React.Fragment>
					);
				})}
			</ChakraBreadcrumb.List>
		</ChakraBreadcrumb.Root>
	);
}
export default Breadcrumb;
